export default function convertOrderLineToGoogleTagManagerItem(line) {
    if (line.type !== 0) {
        return null;
    }
    if (!line.uuid) {
        return null;
    }
    const item = Object.assign({ item_id: getProductId(line), item_name: getItemName(line), item_category: getItemCategory(line), price: (line.actualLinePrice / line.quantity).toFixed(2), discount: getDiscount(line), quantity: line === null || line === void 0 ? void 0 : line.quantity }, getVariantInfo(line));
    // Handle template variants
    if ("template" in line) {
        line.template.categories.forEach((category, index) => {
            // Add +2 as "item_category" is "1"
            const key = `item_category_${index + 2}`;
            item[key] = category;
        });
    }
    if ("package" in line) {
        item["item_name_in_package"] = line.package.packageItems
            .map((packageItem) => {
            var _a;
            return (_a = packageItem.product) === null || _a === void 0 ? void 0 : _a.name;
        })
            .join(";");
    }
    return item;
}
function getItemCategory(line) {
    if ("package" in line) {
        return "PACKAGE_PRODUCTS";
    }
    else if ("catalogue" in line) {
        return "CATALOGUE";
    }
    else if ("template" in line) {
        return "TEMPLATE_PRODUCT";
    }
    else if ("digitalFiles" in line) {
        return "DIGITAL_PRODUCT";
    }
    else {
        return "OTHER_PRODUCT";
    }
}
function getProductId(line) {
    if ("package" in line) {
        return line.package.uuid;
    }
    return line.product.uuid;
}
function getDiscount(line) {
    return "0.00";
    /* Discount should only be used for rebate code, which is not currently
     supported
    if (line.rebate && line.rebate.linePrice) {
      return Math.abs(line.rebate.linePrice).toFixed(2);
    } else {
      return "0.00";
    }*/
}
function getVariantInfo(line) {
    if ("package" in line) {
        const variant = line.package.packageItems
            .map((packageItem) => getPackageItemVariant(packageItem))
            .join(";");
        const variantIds = line.package.packageItems
            .map((packageItem) => getPackageItemVariantId(packageItem))
            .join(";");
        return {
            item_variant: variant,
            item_variant_id: variantIds,
        };
    }
    else if ("template" in line) {
        return {
            item_variant: line.template.name,
            item_variant_id: line.template.uuid,
        };
    }
    return {};
}
function getItemName(line) {
    var _a;
    if ("package" in line) {
        return line.package.name;
    }
    return (_a = line.product) === null || _a === void 0 ? void 0 : _a.name;
}
function getPackageItemVariant(packageItem) {
    if (packageItem.type === "TEMPLATE_PRODUCT") {
        return packageItem.template.name;
    }
    if (packageItem.type === "CATALOGUE") {
        return packageItem.catalogue.name;
    }
    if (packageItem.type === "DIGITAL_SET" ||
        packageItem.type === "DIGITAL_FILE") {
        return `${packageItem.subject.group}: ${packageItem.subject.name}`;
    }
    return "none";
}
function getPackageItemVariantId(packageItem) {
    if (packageItem.type === "TEMPLATE_PRODUCT") {
        return packageItem.template.uuid;
    }
    if (packageItem.type === "CATALOGUE") {
        return packageItem.catalogue.uuid;
    }
    if (packageItem.type === "DIGITAL_SET" ||
        packageItem.type === "DIGITAL_FILE") {
        return packageItem.files.map((file) => file.uuid).join(",");
    }
    return "none";
}
